import { Api } from "../../Api";

export const getRankedNFTsCollectionService = async (
  page: number = 1,
  limit: number = 10,
  score: number | string = "",
  network: string | number = "",
  popularity: number | string = "",
  price: number | string = ""
) => {
  let url = `/collection/get-collection-ranking?`;

  if (page) {
    url += `page=${page}&`;
  }

  if (limit) {
    url += `limit=${limit}&`;
  }

  if (score) {
    url += `score=${score}&`;
  }

  if (network) {
    url += `chainId=${network}&`;
  }

  if (popularity) {
    url += `popularity=${popularity}&`;
  }

  if (price) {
    url += `price=${price}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;
  const response = await Api.get(url);
  return response;
};
